import { Text, View } from 'react-native'
import { DENSE_TABLE_MAX_FONT_SCALE } from '../leagueDetail.constants'
import type { LeagueStandingsTableStyles } from './LeagueStandingsTable.styles'

interface FullHeaderProps {
  styles: LeagueStandingsTableStyles
  isCompactMobile: boolean
}

export function FullHeader({ styles, isCompactMobile }: FullHeaderProps) {
  return (
    <View style={styles.headerRow}>
      <View style={styles.headerRowPadStart} />
      <View style={styles.headerCellRank}>
        <Text style={styles.headerStatLabel}>#</Text>
      </View>
      <View style={styles.headerCellTeam}>
        <View style={styles.headerTeamKitSpacer} />
        <Text style={styles.headerTextTeam} numberOfLines={1} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
          Team
        </Text>
      </View>
      {(['Pl', 'W', 'D', 'L', ...(isCompactMobile ? [] : (['F', 'A'] as const)), 'GD'] as const).map((label) => (
        <View key={label} style={styles.tableSymCell}>
          <Text style={styles.headerStatSym} numberOfLines={1} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
            {label}
          </Text>
        </View>
      ))}
      <View style={styles.tableSymCellPts}>
        <Text style={styles.headerStatLabelEnd} numberOfLines={1} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
          Pts
        </Text>
      </View>
    </View>
  )
}
